/* Round twenty-one (2026-08-30), delivery: the product page's inline script
   (sections/cl-main-product.liquid: gallery, accordions, sticky bar, specs
   jump, review toast, zoom modal, videos row, chips, variants) as a
   cacheable asset, loaded with defer. One init per [data-cl-product] root,
   re-run on shopify:section:load. The values the inline script took from
   Liquid (toast timing, currency, the two button labels, the variants) come
   from the <script type="application/json" data-cl-product-config> blob the
   section writes inside its root. */
(function () {
  function init(root) {
  if (!root || root.dataset.clProductReady === '1') return;
  root.dataset.clProductReady = '1';
  /* the section's settings and the product's variants, as JSON inside the root */
  var CFG = {};
  try { var cfgEl = root.querySelector('[data-cl-product-config]'); CFG = (cfgEl && JSON.parse(cfgEl.textContent)) || {}; } catch (err) { CFG = {}; }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* gallery: the track is a scroll-snap container, so a finger swipe works
     with no script, and the track's own scroll position is what marks the
     active thumbnail. Round eighteen (client, 2026-08-27, "slow to move,
     unintuitive"): every programmatic step -- thumbnail, arrow, key, the
     modal closing -- is one 220ms glide of scrollLeft with the snap switched
     off for its duration; the browser's smooth scroll it replaces walked
     every frame in between, so a jump from the first thumbnail to the fifth
     took the best part of a second. A mouse drag slides the frames too, and
     a press that did not move is a click, which opens the modal. */
  var track = root.querySelector('[data-cl-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cl-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cl-thumb]'));
  var current = 0;
  var glide = null;

  function slideLeft(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
  function stopGlide() {
    if (!glide) return;
    cancelAnimationFrame(glide.raf);
    glide = null;
    track.classList.remove('is-gliding');
  }
  function goTo(i, instant) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    mark(i);
    var from = track.scrollLeft, to = slideLeft(i);
    stopGlide();
    if (instant || reduced || Math.abs(to - from) < 2) { track.scrollLeft = to; return; }
    track.classList.add('is-gliding');
    var start = performance.now(), dur = 220;
    glide = { raf: 0 };
    (function step(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      track.scrollLeft = from + (to - from) * eased;
      if (t < 1) { glide.raf = requestAnimationFrame(step); return; }
      track.scrollLeft = to;
      glide = null;
      track.classList.remove('is-gliding');
    })(start);
  }
  var strip = root.querySelector('[data-cl-thumbs]');
  var stripNext = root.querySelector('[data-cl-thumbs-next]');
  /* keep the marked thumbnail inside the strip's own scroll box; only the
     strip scrolls, never the page */
  function reveal(i) {
    if (!strip || !thumbs[i]) return;
    var sr = strip.getBoundingClientRect(), tr = thumbs[i].getBoundingClientRect();
    if (tr.left < sr.left) strip.scrollBy({ left: tr.left - sr.left - 8, behavior: reduced ? 'auto' : 'smooth' });
    else if (tr.right > sr.right - 40) strip.scrollBy({ left: tr.right - sr.right + 48, behavior: reduced ? 'auto' : 'smooth' });
  }
  function mark(i) {
    current = i;
    slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === i); });
    thumbs.forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      if (k === i) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    reveal(i);
    /* the strip's arrow has nothing left to step to on the last image */
    if (stripNext) stripNext.classList.toggle('is-end', i >= slides.length - 1);
  }
  if (track && slides.length > 1) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking || glide) return;   /* a glide marked its target up front */
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current && slides[i]) mark(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(+t.dataset.clThumb); });
    });
    if (stripNext) stripNext.addEventListener('click', function () { goTo(Math.min(slides.length - 1, current + 1)); });
    var stagePrev = root.querySelector('[data-cl-stage-prev]'), stageNext = root.querySelector('[data-cl-stage-next]');
    if (stagePrev) stagePrev.addEventListener('click', function () { goTo(current - 1); });
    if (stageNext) stageNext.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });
    /* mouse drag: the frames follow the pointer (snap off while it moves),
       and on release the pull settles on the next frame in its direction
       past 40px, else on the nearest. The click that would follow a drag is
       swallowed so a drag never opens the modal; a press that never moved
       6px is left alone and reaches the frame's link as a plain click. */
    var drag = null, swallowClick = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      stopGlide();
      drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(drag.id); } catch (err) {}
      }
      track.scrollLeft = drag.left - dx;
    });
    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var moved = drag.moved, dx = e.clientX - drag.x;
      drag = null;
      if (!moved) return;
      swallowClick = true;
      var pos = track.scrollLeft / Math.max(1, track.clientWidth);
      var i = dx < -40 ? Math.ceil(pos - .02) : dx > 40 ? Math.floor(pos + .02) : Math.round(pos);
      /* the glide goes first so the snap never comes back between the two
         classes: re-enabled mid-way, Chrome would animate to the NEAREST
         frame on its own and win against the glide to the chosen one */
      goTo(Math.max(0, Math.min(slides.length - 1, i)));
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) {
      if (!swallowClick) return;
      swallowClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* a touch swipe or a trackpad scroll that lands mid-glide takes over */
    track.addEventListener('touchstart', stopGlide, { passive: true });
    track.addEventListener('wheel', stopGlide, { passive: true });
    /* the frames are 100% of the track, so a resize shifts every snap
       point; land on the current one again */
    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(current, true); }, 120);
    });
  }
  /* the zoom pill opens the modal on the frame that is showing; a frame
     without a link (a video) falls back to the first image */
  var zoomHint = root.querySelector('[data-cl-zoom]');
  if (zoomHint) zoomHint.addEventListener('click', function () {
    var a = slides[current] && slides[current].querySelector('[data-cl-open]');
    openLightbox(a ? +a.dataset.clOpen : -1);
  });

  /* detail accordions: <details> opens instantly on its own; this grows and
     shrinks the body around it over 400ms, the way cl-specs did. */
  var panels = Array.prototype.slice.call(root.querySelectorAll('.cl-product__panel'));
  function animatePanel(item, opening) {
    var body = item.querySelector('.cl-product__panel-body');
    if (!body || reduced) { if (!opening) item.open = false; return; }
    var target = body.scrollHeight;
    item.setAttribute('data-animating', '');
    body.style.height = opening ? '0px' : target + 'px';
    void body.offsetHeight;
    body.style.height = opening ? target + 'px' : '0px';
    body.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'height') return;
      body.removeEventListener('transitionend', done);
      body.style.height = '';
      item.removeAttribute('data-animating');
      if (!opening) item.open = false;
    });
  }
  panels.forEach(function (item) {
    var head = item.querySelector('summary');
    if (!head) return;
    head.addEventListener('click', function (e) {
      if (reduced) return;
      if (!item.open) { requestAnimationFrame(function () { animatePanel(item, true); }); }
      else { e.preventDefault(); animatePanel(item, false); }
    });
  });

  /* sticky bar: up once the buy stack has scrolled out at the top, down again
     when it is back in view. The bar's add-to-cart (commerce_enabled only)
     submits the form in the column; the enquiry link needs nothing. */
  var sticky = root.querySelector('[data-cl-sticky]');
  var anchor = root.querySelector('[data-cl-buy]') || root.querySelector('.cl-product__buttons');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var out = !en.isIntersecting && en.boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-on', out);
      sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
      root.classList.toggle('has-sticky', out);
    }, { threshold: 0 }).observe(anchor);
    var top = root.querySelector('[data-cl-sticky-top]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); });
    var stickyAtc = root.querySelector('[data-cl-sticky-atc]');
    var form = root.querySelector('.cl-product__form');
    if (stickyAtc && form) stickyAtc.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    });
  }

  /* "Spezifikationen ansehen" (round eighteen): the pill is an anchor to the
     Spezifikationen accordion (else the spec card), whose scroll-margin-top
     clears the sticky nav, so it works with no script. With script a closed
     accordion opens first, the scroll is smooth, and the summary takes focus
     so a keyboard lands where the eye did. */
  var specsGo = root.querySelector('[data-cl-specs-go]');
  if (specsGo) specsGo.addEventListener('click', function (e) {
    var id = (specsGo.getAttribute('href') || '').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var det = target.tagName === 'DETAILS' ? target : null;
    if (det && !det.open) {
      det.open = true;
      if (!reduced) requestAnimationFrame(function () { animatePanel(det, true); });
    }
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    /* --cl-nav-h is the bar's bottom edge as the nav last measured it. At the
       top of the page that includes the utility strip above the bar; the strip
       scrolls away on the way down and the bar ends 35px higher than the
       margin assumed, so the panel lands that much too low. Once the scroll
       has settled the nav has re-measured, the margin resolves right, and one
       more scrollIntoView is a short nudge rather than a second jump. */
    function settle() {
      var nav = document.querySelector('.cl-nav__bar') || document.querySelector('.cl-nav');
      if (!nav) return;
      var navH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cl-nav-h')) || 0;
      var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      var want = nav.getBoundingClientRect().bottom + margin - navH;
      if (Math.abs(target.getBoundingClientRect().top - want) > 4) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }
    if ('onscrollend' in window) window.addEventListener('scrollend', settle, { once: true });
    else setTimeout(settle, reduced ? 60 : 600);
    var focusEl = det ? det.querySelector('summary') : target;
    if (focusEl) {
      if (!det && !focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1');
      focusEl.focus({ preventScroll: true });
    }
    try { history.replaceState(null, '', '#' + id); } catch (err) {}
  });

  /* review toast: one review a few seconds, every `toast_every` seconds,
     desktop only; a close stays closed for the session */
  var toast = root.querySelector('[data-cl-toast]');
  var toastData = root.querySelector('[data-cl-toast-data]');
  var wide = window.matchMedia('(min-width: 992px)');
  if (toast && toastData && wide.matches) {
    var list = [];
    try { list = JSON.parse(toastData.textContent) || []; } catch (e) { list = []; }
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('cl-toast-off') === '1'; } catch (e) {}
    if (list.length && !dismissed) {
      var every = CFG.toastEvery != null ? CFG.toastEvery : 15000;
      var stay = CFG.toastStay != null ? CFG.toastStay : 7000;
      var k = 0, hideTimer = null;
      var nameEl = toast.querySelector('[data-cl-toast-name]');
      var quoteEl = toast.querySelector('[data-cl-toast-quote]');
      var starsEl = toast.querySelector('[data-cl-toast-stars]');
      var avatarEl = toast.querySelector('[data-cl-toast-avatar]');
      function show() {
        var r = list[k % list.length]; k++;
        if (nameEl) nameEl.textContent = r.name || '';
        if (quoteEl) quoteEl.textContent = r.quote || '';
        if (starsEl) starsEl.textContent = new Array((r.stars || 5) + 1).join('★');
        if (avatarEl) avatarEl.textContent = (r.name || '?').trim().charAt(0).toUpperCase();
        toast.hidden = false;
        toast.style.setProperty('--cl-toast-stay', stay + 'ms');
        var fill = toast.querySelector('[data-cl-toast-fill]');
        if (fill) { fill.classList.remove('is-run'); void fill.offsetWidth; fill.classList.add('is-run'); }
        void toast.offsetHeight;
        toast.classList.add('is-on');
        clearTimeout(hideTimer);
        hideTimer = setTimeout(hide, stay);
      }
      function hide() {
        toast.classList.remove('is-on');
        setTimeout(function () { if (!toast.classList.contains('is-on')) toast.hidden = true; }, 450);
      }
      var loop = setInterval(show, every);
      var first = setTimeout(show, Math.min(every, 6000));
      var close = toast.querySelector('[data-cl-toast-close]');
      if (close) close.addEventListener('click', function () {
        clearInterval(loop); clearTimeout(first); clearTimeout(hideTimer); hide();
        try { sessionStorage.setItem('cl-toast-off', '1'); } catch (e) {}
      });
    }
  }

  /* zoom modal: a <dialog> with the large image, arrows, a thumbnail strip
     and (round eighteen, client 2026-08-27: "zoom out missing, very buggy")
     a tool row of minus / plus / close. The frame links point at the
     full-size file, so without script they still open the image.

     Zoom model: the wrap carries translate(tx, ty) scale(s) from its top
     left corner, so a zoom around any point (a click, the wheel, a pinch's
     midpoint) keeps that point still under the pointer, and the pan is
     clamped so the photo covers the stage while zoomed and never drifts
     off. A click zooms in 2.5x and a second click resets; the buttons step
     1.5x; the wheel (and a trackpad pinch, which arrives as a wheel) is
     continuous; two fingers pinch; Escape resets before it closes. The
     image gets an explicit fitted size from its own aspect, so swapping the
     frame's already loaded file for the 2000px one never moves it. */
  var dialog = root.querySelector('[data-cl-lightbox]');
  var lbImage = root.querySelector('[data-cl-lb-image]');
  var lbWrap = root.querySelector('[data-cl-lb-wrap]');
  var lbStage = dialog ? dialog.querySelector('.cl-product__lb-stage') : null;
  var lbThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cl-lb-go]'));
  var lbNow = root.querySelector('[data-cl-lb-now]');
  var lbZoomIn = root.querySelector('[data-cl-lb-zoom-in]'), lbZoomOut = root.querySelector('[data-cl-lb-zoom-out]');
  var links = Array.prototype.slice.call(root.querySelectorAll('[data-cl-open]'));
  var lbIndex = 0, lbLoad = 0;
  var SCALE_MAX = 4, SCALE_CLICK = 2.5, SCALE_STEP = 1.5;
  var scale = 1, tx = 0, ty = 0;

  /* links carry the media index; a video in the middle of the media list
     has no link, so the modal walks the links and maps back to media */
  function linkPos(mediaIndex) {
    for (var k = 0; k < links.length; k++) if (+links[k].dataset.clOpen === mediaIndex) return k;
    return -1;
  }
  function fitImage() {
    if (!lbStage || !lbImage || !links[lbIndex]) return;
    var img = links[lbIndex].querySelector('img');
    var w = (img && (img.naturalWidth || +img.getAttribute('width'))) || 4;
    var h = (img && (img.naturalHeight || +img.getAttribute('height'))) || 3;
    var cs = getComputedStyle(lbStage);
    var aw = lbStage.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var ah = lbStage.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    if (aw <= 0 || ah <= 0) return;
    var k = Math.min(aw / w, ah / h);
    lbImage.style.width = Math.round(w * k) + 'px';
    lbImage.style.height = Math.round(h * k) + 'px';
  }
  function applyZoom(instant) {
    if (!lbWrap) return;
    lbWrap.classList.toggle('is-instant', !!instant);
    lbWrap.style.transform = scale === 1 ? '' : 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    lbWrap.classList.toggle('is-zoomed', scale > 1);
    if (dialog) dialog.classList.toggle('is-zoomed', scale > 1);
    if (lbZoomOut) lbZoomOut.disabled = scale <= 1;
    if (lbZoomIn) lbZoomIn.disabled = scale >= SCALE_MAX;
  }
  /* the wrap's untransformed box: the rendered one minus the translation,
     divided by the scale (the origin is the top left corner) */
  function baseRect() {
    var r = lbWrap.getBoundingClientRect();
    return { left: r.left - tx, top: r.top - ty, width: r.width / scale, height: r.height / scale };
  }
  function clampPan() {
    if (!lbStage) return;
    var b = baseRect(), s = lbStage.getBoundingClientRect();
    var w = b.width * scale, h = b.height * scale;
    var l = b.left - s.left, t = b.top - s.top;
    tx = w <= s.width ? (s.width - w) / 2 - l : Math.min(-l, Math.max(s.width - l - w, tx));
    ty = h <= s.height ? (s.height - h) / 2 - t : Math.min(-t, Math.max(s.height - t - h, ty));
  }
  function setScale(next, x, y, instant) {
    if (!lbWrap) return;
    next = Math.max(1, Math.min(SCALE_MAX, next));
    if (next < 1.04) next = 1;
    if (next === 1) { scale = 1; tx = ty = 0; applyZoom(instant); return; }
    var b = baseRect();
    if (x == null) { x = b.left + tx + b.width * scale / 2; y = b.top + ty + b.height * scale / 2; }
    /* the photo point under (x, y) stays under it */
    var px = x - b.left, py = y - b.top;
    var qx = (px - tx) / scale, qy = (py - ty) / scale;
    scale = next;
    tx = px - qx * scale; ty = py - qy * scale;
    clampPan();
    applyZoom(instant);
  }
  function unzoom(instant) { setScale(1, null, null, instant); }
  function revealLbThumb(mediaIndex) {
    var strip = root.querySelector('.cl-product__lb-thumbs');
    var t = lbThumbs.filter(function (b) { return +b.dataset.clLbGo === mediaIndex; })[0];
    if (!strip || !t) return;
    var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
    if (tr.left < sr.left) strip.scrollBy({ left: tr.left - sr.left - 8, behavior: reduced ? 'auto' : 'smooth' });
    else if (tr.right > sr.right) strip.scrollBy({ left: tr.right - sr.right + 8, behavior: reduced ? 'auto' : 'smooth' });
  }
  function showImage(pos) {
    if (!lbImage || !links.length) return;
    lbIndex = (pos + links.length) % links.length;
    var link = links[lbIndex], img = link.querySelector('img'), full = link.getAttribute('href');
    var token = ++lbLoad;
    unzoom(true);
    fitImage();
    /* the frame's file is on screen already; the 2000px one replaces it once
       it has arrived, and only if this is still the image showing */
    var have = img && img.currentSrc;
    lbImage.src = have || full;
    lbImage.alt = img ? img.alt : '';
    if (have && have !== full) {
      var big = new Image();
      big.onload = function () { if (token === lbLoad) lbImage.src = full; };
      big.src = full;
    }
    if (lbNow) lbNow.textContent = lbIndex + 1;
    var mi = +link.dataset.clOpen;
    lbThumbs.forEach(function (t) { t.classList.toggle('is-active', +t.dataset.clLbGo === mi); });
    revealLbThumb(mi);
  }
  function openLightbox(mediaIndex) {
    if (!dialog || !links.length) return;
    var pos = linkPos(mediaIndex);
    if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
    else dialog.setAttribute('open', '');
    showImage(pos < 0 ? 0 : pos);   /* after showModal: the stage has a size to fit into */
  }
  function syncGallery() {
    if (links[lbIndex]) goTo(+links[lbIndex].dataset.clOpen, true);
  }
  function closeLightbox() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else { dialog.removeAttribute('open'); unzoom(true); syncGallery(); }
  }
  if (dialog) {
    links.forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openLightbox(+a.dataset.clOpen); });
    });
    var lbClose = root.querySelector('[data-cl-lb-close]');
    var lbPrev = root.querySelector('[data-cl-lb-prev]'), lbNext = root.querySelector('[data-cl-lb-next]');
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lbPrev) lbPrev.addEventListener('click', function () { showImage(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { showImage(lbIndex + 1); });
    if (lbZoomIn) lbZoomIn.addEventListener('click', function () { setScale(scale * SCALE_STEP); });
    /* minus lands on 1 rather than leaving a 1.1x that looks like nothing
       happened: a click zoom (2.5x) is two presses back, the pinch's 4x three */
    if (lbZoomOut) lbZoomOut.addEventListener('click', function () { var next = scale / SCALE_STEP; setScale(next < 1.3 ? 1 : next); });
    lbThumbs.forEach(function (t) {
      t.addEventListener('click', function () { var pos = linkPos(+t.dataset.clLbGo); if (pos >= 0) showImage(pos); });
    });
    dialog.addEventListener('close', function () { unzoom(true); syncGallery(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showImage(lbIndex - 1);
      else if (e.key === 'ArrowRight') showImage(lbIndex + 1);
      else if (e.key === '+' || e.key === '=') setScale(scale * SCALE_STEP);
      else if (e.key === '-' || e.key === '_') setScale(scale / SCALE_STEP);
      else if (e.key === 'Escape' && scale > 1) { e.preventDefault(); unzoom(); }
    });
    window.addEventListener('resize', function () {
      if (!dialog.open) return;
      fitImage();
      clampPan();
      applyZoom(true);
    });
    if (lbStage) {
      /* pointers on the stage: one finger or the mouse drags (pans while
         zoomed, swipes to the next image while not), two fingers pinch, a
         press that never moved is a click that zooms in or resets. The
         arrows and tools are buttons and keep their own clicks. */
      var ptrs = {}, nPtrs = 0, gesture = null;
      function ptrList() { var a = []; for (var k in ptrs) a.push(ptrs[k]); return a; }
      function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
      lbStage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('button')) return;
        ptrs[e.pointerId] = { x: e.clientX, y: e.clientY }; nPtrs++;
        try { lbStage.setPointerCapture(e.pointerId); } catch (err) {}
        if (nPtrs === 1) gesture = { kind: 'drag', x: e.clientX, y: e.clientY, tx: tx, ty: ty, moved: false };
        else if (nPtrs === 2) { var p = ptrList(); gesture = { kind: 'pinch', d: Math.max(1, dist(p[0], p[1])), s: scale, moved: true }; }
      });
      lbStage.addEventListener('pointermove', function (e) {
        var p = ptrs[e.pointerId];
        if (!p || !gesture) return;
        p.x = e.clientX; p.y = e.clientY;
        if (gesture.kind === 'pinch') {
          if (nPtrs < 2) return;
          var l = ptrList(), d = dist(l[0], l[1]);
          setScale(gesture.s * d / gesture.d, (l[0].x + l[1].x) / 2, (l[0].y + l[1].y) / 2, true);
          return;
        }
        var dx = e.clientX - gesture.x, dy = e.clientY - gesture.y;
        if (!gesture.moved && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        gesture.moved = true;
        if (scale > 1) { tx = gesture.tx + dx; ty = gesture.ty + dy; clampPan(); applyZoom(true); }
      });
      function ptrUp(e) {
        if (!ptrs[e.pointerId]) return;
        delete ptrs[e.pointerId]; nPtrs--;
        var g = gesture;
        if (nPtrs > 0) {   /* one finger left after a pinch: carry on as a pan from where it is */
          var l = ptrList();
          gesture = { kind: 'drag', x: l[0].x, y: l[0].y, tx: tx, ty: ty, moved: true };
          return;
        }
        gesture = null;
        if (!g || g.kind === 'pinch' || e.type === 'pointercancel') return;
        var dx = e.clientX - g.x, dy = e.clientY - g.y;
        if (!g.moved) {
          if (scale > 1) { unzoom(); return; }
          var r = lbImage.getBoundingClientRect();
          if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) setScale(SCALE_CLICK, e.clientX, e.clientY);
          return;
        }
        if (scale === 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showImage(lbIndex + (dx < 0 ? 1 : -1));
      }
      lbStage.addEventListener('pointerup', ptrUp);
      lbStage.addEventListener('pointercancel', ptrUp);
      lbStage.addEventListener('wheel', function (e) {
        e.preventDefault();
        var f = Math.exp(-e.deltaY * (e.deltaMode === 1 ? .05 : .002));
        setScale(scale * f, e.clientX, e.clientY);
      }, { passive: false });
      lbStage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }

  /* videos: the row scrolls a card at a time; a file card previews muted
     while hovered; any card opens its film with sound in the row's dialog */
  var vids = root.querySelector('[data-cl-videos]');
  if (vids) {
    var vTrack = vids.querySelector('[data-cl-videos-track]');
    var vPrev = vids.querySelector('[data-cl-videos-prev]');
    var vNext = vids.querySelector('[data-cl-videos-next]');
    function vStep() {
      var card = vTrack.querySelector('.cl-product__video-card');
      var gap = parseFloat(getComputedStyle(vTrack).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : vTrack.clientWidth;
    }
    function vSync() {
      var max = vTrack.scrollWidth - vTrack.clientWidth;
      if (vPrev) vPrev.hidden = vTrack.scrollLeft <= 2;
      if (vNext) vNext.hidden = vTrack.scrollLeft >= max - 2;
    }
    if (vTrack) {
      if (vPrev) vPrev.addEventListener('click', function () { vTrack.scrollBy({ left: -vStep(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (vNext) vNext.addEventListener('click', function () { vTrack.scrollBy({ left: vStep(), behavior: reduced ? 'auto' : 'smooth' }); });
      vTrack.addEventListener('scroll', vSync, { passive: true });
      window.addEventListener('resize', vSync);
      vSync();
    }
    /* YouTube has no maxresdefault for every film; fall back to hqdefault */
    vids.querySelectorAll('[data-cl-poster-alt]').forEach(function (img) {
      img.addEventListener('error', function () {
        var alt = img.dataset.clPosterAlt;
        img.removeAttribute('data-cl-poster-alt');
        if (alt) img.src = alt;
      });
    });
    var hoverable = window.matchMedia('(hover: hover)').matches;
    vids.querySelectorAll('.cl-product__video-card.is-mp4').forEach(function (card) {
      var loop = card.querySelector('[data-cl-video-loop]');
      if (!loop || reduced || !hoverable) return;
      var start = function () { loop.play().catch(function () {}); card.classList.add('is-previewing'); };
      var stop = function () { loop.pause(); try { loop.currentTime = 0; } catch (e) {} card.classList.remove('is-previewing'); };
      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', stop);
    });
    var vDialog = vids.querySelector('[data-cl-video-dialog]');
    var vFrame = vids.querySelector('[data-cl-video-frame]');
    var vPlayer = null;
    function vDrop() { if (vPlayer) { if (vPlayer.pause) vPlayer.pause(); vPlayer.remove(); vPlayer = null; } }
    function vShut() { if (!vDialog) return; if (typeof vDialog.close === 'function') vDialog.close(); else vDialog.removeAttribute('open'); vDrop(); }
    vids.querySelectorAll('[data-cl-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!vDialog || !vFrame) return;
        vDrop();
        var kind = btn.dataset.clVideoKind;
        if (kind === 'mp4') {
          vPlayer = document.createElement('video');
          vPlayer.src = btn.dataset.clVideoOpen;
          vPlayer.controls = true; vPlayer.autoplay = true; vPlayer.playsInline = true;
          vDialog.classList.toggle('is-wide', !vids.classList.contains('is-portrait'));
        } else {
          vPlayer = document.createElement('iframe');
          vPlayer.src = btn.dataset.clVideoOpen;
          vPlayer.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
          vPlayer.setAttribute('allowfullscreen', '');
          vPlayer.setAttribute('title', btn.getAttribute('aria-label') || '');
          vDialog.classList.add('is-wide');
        }
        vFrame.appendChild(vPlayer);
        if (typeof vDialog.showModal === 'function') vDialog.showModal(); else vDialog.setAttribute('open', '');
        if (vPlayer.play) vPlayer.play().catch(function () {});
      });
    });
    if (vDialog) {
      var vClose = vDialog.querySelector('[data-cl-video-close]');
      if (vClose) vClose.addEventListener('click', vShut);
      vDialog.addEventListener('close', vDrop);
      vDialog.addEventListener('click', function (e) { if (e.target === vDialog) vShut(); });
    }
  }

  /* Round fifteen item 6: the chips are an accordion on a phone and a plain
     list everywhere else. One button either way; which of the two it is comes
     from the same breakpoint the stylesheet uses, read once and on resize, so
     a phone that turns landscape past 767 gets the list back open. */
  var chipsToggle = root.querySelector('[data-cl-chips-toggle]');
  if (chipsToggle) {
    var chipsBlock = chipsToggle.closest('[data-cl-chips]');
    var phone = window.matchMedia('(max-width: 767px)');
    var syncChips = function () {
      var on = phone.matches;
      chipsBlock.classList.toggle('is-accordion', on);
      if (!on) { chipsBlock.classList.add('is-open'); chipsToggle.setAttribute('aria-expanded', 'true'); }
      else if (!chipsBlock.dataset.touched) { chipsBlock.classList.remove('is-open'); chipsToggle.setAttribute('aria-expanded', 'false'); }
    };
    chipsToggle.addEventListener('click', function () {
      if (!phone.matches) return;
      chipsBlock.dataset.touched = '1';
      var open = chipsBlock.classList.toggle('is-open');
      chipsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (phone.addEventListener) phone.addEventListener('change', syncChips);
    else if (phone.addListener) phone.addListener(syncChips);
    syncChips();
  }

  /* feature chips: "+N mehr" reveals the rest */
  var chipsMore = root.querySelector('[data-cl-chips-more]');
  if (chipsMore) chipsMore.addEventListener('click', function () {
    root.querySelectorAll('.cl-product__chip.is-more').forEach(function (c) { c.hidden = false; });
    chipsMore.setAttribute('aria-expanded', 'true');
    chipsMore.closest('li').hidden = true;
  });

  /* Add to cart through the Ajax API (ANZ, 2026-10-08; EU/UK add-ons, D-0978). The plain post to
     /cart/add still works without script; with script the add goes through
     /cart/add.js first, so the PostHog cart identity (order stitching) is on
     the cart before the visitor lands on it, then on to /cart as before. Any
     failure (sold out, network) falls back to the plain post. */
  var buyForm = root.querySelector('.cl-product__form');
  if (buyForm && window.fetch && window.FormData && !buyForm.hasAttribute('data-cl-ajax')) {
    buyForm.setAttribute('data-cl-ajax', '');
    buyForm.setAttribute('data-ph-js-cart', '');
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (buyForm.__clPosting) return;
      buyForm.__clPosting = true;
      var btn = buyForm.querySelector('[data-cl-add]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      var toCart = function () { window.location.href = cartRoot + 'cart'; };
      var fallback = function () {
        buyForm.__clPosting = false;
        if (btn) btn.removeAttribute('aria-busy');
        HTMLFormElement.prototype.submit.call(buyForm);
      };
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(buyForm)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add ' + r.status);
        return r.json();
      }).then(function (item) {
        var detail = { item: item, form: buyForm, wait: null };
        document.dispatchEvent(new CustomEvent('cl:cart-added', { detail: detail }));
        /* store mode commerce with the cart drawer (cl-commerce.js): the drawer opened, stay here */
        if (detail.handled) { buyForm.__clPosting = false; if (btn) btn.removeAttribute('aria-busy'); return; }
        if (detail.wait && detail.wait.then) {
          Promise.race([detail.wait, new Promise(function (r) { setTimeout(r, 800); })]).then(toCart, toCart);
        } else toCart();
      }).catch(fallback);
    });
  }

  /* variant selection, matched on the option value tuple. Only wired up when
     the product has options at all, which most of this catalogue does not,
     and only with commerce_enabled on, because the selects live in the form. */
  var selects = root.querySelectorAll('[data-cl-option]');
  var idField = root.querySelector('[data-cl-variant-id]');
  if (!selects.length || !idField) return;

  var variants = CFG.variants || [];
  var addBtn = root.querySelector('[data-cl-add]');
  var addLabel = root.querySelector('[data-cl-add-label]');
  var addPrice = root.querySelector('[data-cl-add-price]');
  var priceEl = root.querySelector('[data-cl-price]');
  var compareEl = root.querySelector('[data-cl-compare]');
  var stickyPrice = root.querySelector('[data-cl-sticky-price]');
  var currency = CFG.currency || 'EUR';
  var locale = document.documentElement.lang || 'de';
  var fmt = function (cents) { return (cents / 100).toLocaleString(locale, { style: 'currency', currency: currency }); };

  function pick() {
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variants.find(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    });
    if (!match) return;
    idField.value = match.id;
    if (addBtn) addBtn.disabled = !match.available;
    if (addLabel) {
      addLabel.textContent = match.available
        ? (CFG.addToCart || '')
        : (CFG.soldOut || '');
    }
    if (addPrice && match.price != null) {
      addPrice.textContent = fmt(match.price);
      addPrice.hidden = !match.available;
    }
    if (priceEl && match.price != null) priceEl.textContent = fmt(match.price);
    if (stickyPrice && match.price != null) stickyPrice.textContent = fmt(match.price);
    if (compareEl) {
      var onSale = match.compare_at_price != null && match.compare_at_price > match.price;
      compareEl.hidden = !onSale;
      if (onSale) compareEl.textContent = fmt(match.compare_at_price);
    }
    var url = new URL(window.location);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  }
  selects.forEach(function (s) { s.addEventListener('change', pick); });
  }
  function scan(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-cl-product]')) init(scope);
    if (scope.querySelectorAll) Array.prototype.forEach.call(scope.querySelectorAll('[data-cl-product]'), init);
  }
  /* The tag is emitted once per instance and the theme editor re-inserts it
     with a re-rendered section, so a second run only scans for new roots. */
  if (window.clProductScan) { window.clProductScan(document); return; }
  window.clProductScan = scan;
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
